import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import {
  ARROW_NEXT,
  ARROW_PREV,
  AVTAR_IMG,
  GALLERY_1,
  GALLERY_2,
  GALLERY_3,
  GIRLICON_IMG,
  HOME_IMG,
  NODATAFOUND,
} from "../../../utils/app-image-contant";
import Crousel from "../../../components/common/Crousel";
import Button from "../../../components/common/button";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../hooks/routes/url-constant";
import { useTranslation } from "react-i18next";
import {
  getAllHomeImageData,
  getSuccessStroyYoutubeVideo,
  getWhatsNewAndNewsLetter,
  getYoutubeVideo,
} from "../../../hooks/services/api-services";
import { toastEmitter } from "../../../utils/utilities";
import { API_RESPONSE } from "../../../utils/app-constants";
import { TableLoader } from "../../../components/snippets/template-blocks";
import moment from "moment";
import FraudsAlertModal from "../Components/Common/Modal/fraudsAlertModal";
import { useQuery } from "react-query";
import { fetchIframeLinks } from "../../../components/common/ifreamLink";

const Home = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowData, setRowData] = useState([]);
  // const[newsTotalElement,setNewsTotalElement] =useState()
  const [showFraudModal, setShowFraudModal] = useState(false);
  const [homeSectionData, sethomeSectionData] = useState({
    visionData: [],
    ministerData: [],
    latestUpdateData: [],
    ChemicalsinisterCategory: [],
    galleryEventCategory: []
  });
  const [viewLatestUpdate, setViewLatestUpdate] = useState();
  const [Type, setType] = useState("WhatsNew");
  const [totalElement, settotalElement] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const Language = localStorage.getItem("language");
  const [payload, setPayload] = useState({
    pageIndex: page || 0,
    pageSize: pageSize || 10,
    type: Type,
    searchByTitle: "",
  });
  const schemePayload = {
    pageIndex: 0,
    pageSize: 1000,
    columnName: "",
    orderBy: "",
    searchText: "",
  };
  const youtubeVideos = [
    { id: 1, iframe: "https://www.youtube.com/embed/IoNWpwORtXA", title: "Hon’ble Union Home Minister Shri Amit Shah Highlights PACS & Jan Aushadhi at the Rajya Sabha", description: "" },
    { id: 2, iframe: "https://www.youtube.com/embed/eav-Uy1WnZQ", title: "Hon’ble Union Health Minister Shri J P Nadda praises PMBJP in the Rajya Sabha", description: "" },
    { id: 3, iframe: "https://www.youtube.com/embed/XQjQ0MYVP44", title: "India 🤝 Guyana Strengthening Global Healthcare Ties.", description: "" },
    { id: 4, iframe: "https://www.youtube.com/embed/7wVm5qK78wI", title: "Shri Ravi Dadhich, CEO, PMBI, Explains Jan Aushadhi's Impact on Affordable Healthcare with AIR", description: "" },
    { id: 5, iframe: "https://www.youtube.com/embed/MIAS8Uj3_pA", title: "Interview of Shri Amit Agrawal (IAS), Secretary, DoP, GoI at Akashvani AIR News", description: "" },
    { id: 6, iframe: "https://www.youtube.com/embed/2t-m-aaLcXA", title: "Hon’ble PM Shri Narendra Modi addressed in Silvassa on Jan Aushadhi Diwas 2025", description: "" },
    { id: 7, iframe: "https://www.youtube.com/embed/U7-ga9CZ5SY", title: "Shri J. P. Nadda message on Jan Aushadhi Diwas 2025", description: "" },
    { id: 8, iframe: "https://www.youtube.com/embed/Pln14OM2V68", title: "Smt Anupriya Patel message on 7th Jan Aushadhi Diwas 2025", description: "" },
    { id: 9, iframe: "https://www.youtube.com/embed/znCpte9JThg", title: "Jan Aushadhi Diwas 2025: Padma Shri Prof. (Dr.) Mahesh Verma, Vice Chancellor, GGSIP University", description: "" },
    { id: 10, iframe: "https://www.youtube.com/embed/qcDRWmOK19k", title: "Jan Aushadhi Diwas 2025: Dr. Montu Kumar, President, Pharmacy Council of India", description: "" },
    { id: 11, iframe: "https://www.youtube.com/embed/WdY_tkAaXqs", title: "Dr. Ann Liebert, Adjunct Senior Lecturer, Sydney, visited Janaushadhi Kendra at AIIMS, New Delhi", description: "" },
    { id: 12, iframe: "https://www.youtube.com/embed/HRrPe6M3O5I", title: "Jan Aushadhi Diwas 2025: Dr. M Srinivas, Director AIIMS, New Delhi", description: "" },
    { id: 13, iframe: "https://www.youtube.com/embed/GC4-d4OHy6k", title: "Jan Aushadhi Diwas 2025: Dr. M Srinivas, Director AIIMS, New Delhi", description: "" },
    { id: 14, iframe: "https://www.youtube.com/embed/vEysjzj19GA", title: "गुजरात के वडोदरा में जन औषधि सप्ताह 2025 के चलते महिलाओं के लिए विशेष कार्यक्रम का आयोजन।", description: "" },
    { id: 15, iframe: "https://www.youtube.com/embed/RAoChH_ZMJ8", title: "Jan Aushadhi Diwas 2025: Shri Brajesh Pathak, Hon'ble Chief Minister, Uttar Pradesh", description: "" },
    { id: 16, iframe: "https://www.youtube.com/embed/PdOVTithsok", title: "Shri Amit Aggarwal, IAS, Secretary, DoP, interview with ANI", description: "" },
    { id: 17, iframe: "https://www.youtube.com/embed/Dm04cL1UAPo", title: "प्रधानमंत्री भारतीय जनऔषधि परियोजना - दाम कम - दवाई उत्तम I DD News", description: "" },
    { id: 18, iframe: "https://www.youtube.com/embed/GTdZKqTk9Wo", title: "Jan Aushadhi Diwas 2025: Dr Ajay Singh, Director AIIMS, Bhopal", description: "" },
    { id: 19, iframe: "https://www.youtube.com/embed/7_uXvKLoYU8", title: "Jan Aushadhi Diwas 2025: Shri Vijender Gupta, Hon'ble Speaker Delhi Legislative Assembly", description: "" },
    { id: 20, iframe: "https://www.youtube.com/embed/BtqQ8iuX0Gk", title: "Jan Aushadhi Diwas 2025: Smt Rekha Gupta, Honourable Chief Minister, Delhi", description: "" },
  ]
  const youtubeSuccessStory = [
    { id: 1, iframe: "https://www.youtube.com/embed/1vX2SKGRz5A", title: "PMBJP Customer Testimony: Jammu & Kashmir", description: "" },
    { id: 2, iframe: "https://www.youtube.com/embed/Edws36M4rY8", title: "PMBJP Customer Testimony: Tamil Nadu", description: "" },
    { id: 3, iframe: "https://www.youtube.com/embed/5TQhMsuoZUc", title: "PMBJP Customer Testimony: Uttar Pradesh", description: "" },
    { id: 4, iframe: "https://www.youtube.com/embed/RUPKzJ7MCXg", title: "PMBJP Customer Testimony: Maharashtra", description: "" },
    { id: 5, iframe: "https://www.youtube.com/embed/s4-RcDKeiFA", title: "PMBJP Customer Testimony: Manipur", description: "" },
    { id: 6, iframe: "https://www.youtube.com/embed/VAKxQx4HMyo", title: "PMBJP Customer Testimony: Jharkhand", description: "" },
    { id: 7, iframe: "https://www.youtube.com/embed/TImsjw0c854", title: "PMBJP Customer Testimony: Madhya Pradesh", description: "" },
  ]

  useEffect(() => {
    setPayload({ ...payload, type: Type });
  }, [Type]);

   // Modal 
   useEffect(() => {
    // Check if modal has been shown in this session
    const modalShown = sessionStorage.getItem("modalShown");
    if (!modalShown) {
      setShowFraudModal(true);
      sessionStorage.setItem("modalShown", "true");
    }
    // Clear sessionStorage on window refresh
    const handleBeforeUnload = () => {
      sessionStorage.removeItem("modalShown");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleCloseModal = () => {
    setShowFraudModal(false);
    sessionStorage.setItem("modalShown", "true");
  };

  const NewLetterAndWhatsNew = async () => {
    setIsLoading(true);
    try {
      const response = await getWhatsNewAndNewsLetter(payload);
      if (response?.data?.responseCode === 200) {
        setRowData(response?.data.responseBody?.whatsNewAndNewsLatterList);
        settotalElement(response?.data?.responseBody?.totalElement);
        setIsLoading(false);
      } else {
        toastEmitter(
          "error",
          response?.data?.message || API_RESPONSE.MESSAGE_500
        );
        setIsLoading(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const getHomeImage = async () => {
    setIsLoading(true);
    try {
      const response = await getAllHomeImageData(schemePayload);
      if (response?.data?.responseCode === 200) {
        let res = response?.data?.responseBody?.uploadImageLoopList;
        const priministerCategory = res.filter(
          (item) => item.category === "Prime Minister"
        );
        const healthministerCategoryData = res.filter(
          (item) => item.category === "Health Minister"
        );
        const ChemicalsinisterCategoryData = res.filter(
          (item) => item.category === "Chemicals Minister"
        );
        const latestUpdateCategoryData = res.filter(
          (item) => item.category === "Latest Updates"
        );
        const galleryEventData = res.filter(
          (item) => item.category === "Gallery Event"
        );
        sethomeSectionData({
          ...homeSectionData,
          latestUpdateData: latestUpdateCategoryData,
          ministerData: healthministerCategoryData,
          visionData: priministerCategory,
          ChemicalsinisterCategory: ChemicalsinisterCategoryData,
          galleryEventCategory: galleryEventData
        });
        setIsLoading(false);
      } else {
        toastEmitter(
          "error",
          response?.data?.message || API_RESPONSE.MESSAGE_500
        );
        setIsLoading(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  useEffect(() => {
    NewLetterAndWhatsNew();
  }, [pageSize, Type, payload]);

  useEffect(() => {
    getHomeImage();
  }, []);

  const handleShowMoreNews = () => {
    const newPageSize = pageSize + 10;
    setPageSize(newPageSize);
    setPayload(prevPayload => ({
      ...prevPayload,
      pageSize: newPageSize
    }))
  }

  

  const slidersettings = {
    dots: false,
    infinite: true,
    speed: 6000,
    arrow: false,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 3,
    slidesToScroll: 3,
    lazyLoad: 'ondemand',
    // cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 6000,
          lazyLoad: 'ondemand',
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 6000,
          lazyLoad: 'ondemand',
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 6000,
          lazyLoad: 'ondemand',
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 6000,
          lazyLoad: 'ondemand',
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 6000,
          lazyLoad: 'ondemand',
          // cssEase: "linear",
        },
      },
    ],
  };

  const gallerysettings = {
    dots: false,
    infinite: true,
    speed: 6000,
    arrow: false,
    autoplay: true,
    autoplaySpeed: 9000,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    // cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 9000,
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 9000,
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 9000,
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 9000,
          // cssEase: "linear",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 9000,
          // cssEase: "linear",
        },
      },
    ],
  };


  const newssettings = {
    infinite: true,
    speed: 2000,
    arrow: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const { t } = useTranslation();
  const handleNavigatePharma = () => {
    navigate(ROUTES.NEARBYPHARMA);
  };
  const handleNavigateKendra = () => {
    // navigate(ROUTES.NEARBYKENDRA);
    navigate(`${process.env.PUBLIC_URL}/near-by-kendra`);

  };

  const handleNavigationNews = (id) => {
    navigate(`${process.env.PUBLIC_URL}/NewsDetail/${id}`);
  };

  const handleLatestUpdateClick = (data) => {
    setViewLatestUpdate(data);
  };
  const { data: data1 } = useQuery("iframeLinks", fetchIframeLinks, {
    // staleTime: 1000 * 60 * 5,
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 10,
  });

  const latestUpdateData = homeSectionData?.latestUpdateData?.[0] || {};
  // const updateImageUrl =
  //   viewLatestUpdate?.imageUrl || latestUpdateData.imageUrl || AVTAR_IMG;
  // const updateName =
  //   Language === "hi"
  //     ? latestUpdateData.uploadImageHindiResponse?.name
  //     : viewLatestUpdate?.name || latestUpdateData.name;
  // const updateDescription =
  //   Language === "hi"
  //     ? latestUpdateData.uploadImageHindiResponse?.description
  //     : viewLatestUpdate?.description || latestUpdateData.description;


  const [videos, setVideos] = useState([]);
  const [successStoryvideos, setSuccessStoryVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Successloading, setSuccessloading] = useState(true);


  useEffect(() => {
    getLatestYoutubeVideo();
    getSuccessStroy();
  }, [])

  const getLatestYoutubeVideo = async () => {
    try {
      const youtubeRes = await getYoutubeVideo();
      if (youtubeRes.status === 200) {
        const listData = youtubeRes?.data.items.map((item, index) => ({
          id: index + 1,
          iframe: `https://www.youtube.com/embed/${item.id.videoId}`,
          description: item.snippet.description,
          title: item.snippet.title
        }));
        setVideos([...listData]); // Set the video list in state
        setLoading(false);
      } else {
        setVideos(youtubeVideos);
        setLoading(false);
      }
    } catch (error) {
      console.log("Videos Data Error=> ", error?.message);
      setVideos(youtubeVideos);
      setLoading(false);
    }
  }


  const getSuccessStroy = async () => {
    try {
      const youtubeRes = await getSuccessStroyYoutubeVideo();
      if (youtubeRes.status === 200) {
        const listData = youtubeRes?.data.items.map((item, index) => ({
          id: index + 1,
          iframe: `https://www.youtube.com/embed/${item.snippet.resourceId.videoId}`,
          title: item.snippet.title
        }));
        setSuccessStoryVideos([...listData]); // Set the video list in state
        setSuccessloading(false);
      } else {
        setSuccessStoryVideos(youtubeSuccessStory);
        setSuccessloading(false);
      }
    } catch (error) {
      console.log("Success Story Data Error =>", error?.message);
      setSuccessStoryVideos(youtubeSuccessStory);
      setSuccessloading(false);
    }
  }


  return (
    <>
      <Crousel />
      <div className="jana_infotab ja-primary-bg px-3">
        <div className="container-fluid">
          <div className="row">
            {/* First Section */}
            <div className="col-sm-12 col-md-5 col-lg-5 d-flex justify-content-center justify-content-lg-between align-items-center mb-3 mb-lg-0">
              <div className="d-flex flex-wrap justify-content-center justify-content-lg-start align-items-center mt-3 mt-lg-0 rightside">
                <h6
                  className="areupharmacisttext  align-items-center mb-0 mt-3 mt-lg-0 me-3 me-lg-0"
                  id="spanColor"
                >
                  {t("AreYouAPharmacist")}
                </h6>
                <Link to={ROUTES?.PHARMAREGISTER}>
                  <Button
                    buttonName={t("Registerhere")}
                    buttonStyle="border-0 button-bg rounded-3 text-white  mt-3 mt-md-3 mt-lg-0 ms-0 ms-lg-4  me-0 px-5 text-center registerhere"
                  />
                </Link>
              </div>
            </div>

            {/* Second Section */}
            <div className="col-sm-12 col-md-7 col-lg-7 d-flex justify-content-center p-0 ">
              <div className="row  w-100">
                {/* First Inner Column */}
                <div className="col-sm-6 col-md-12 col-lg-6 d-flex justify-content-center align-items-center justify-content-lg-start  p-0 mb-3 mb-md-0">
                  <div className="d-flex align-items-center py-1 kendrabuttons">
                    <img
                      src={GIRLICON_IMG}
                      alt=""
                      className="img-fluid pharmacistimg rounded-3"
                    />
                    <Button
                      buttonName={t("nearPharmacist")}
                      buttonStyle="pharmabutton-bg px-3 ms-2 me-0"
                      handleClick={handleNavigatePharma}
                    />
                  </div>
                </div>
                {/* Second Inner Column */}
                <div className="col-sm-6 col-md-12 col-lg-6 d-flex justify-content-center align-items-center justify-content-lg-end p-0 mb-3 mb-md-0">
                  <div className="d-flex align-items-center py-1 kendrabuttons">
                    <img
                      src={HOME_IMG}
                      alt=""
                      className="img-fluid pharmacistimg rounded-3"
                    />
                    <Button
                      buttonName={t("nearbykendra")}
                      buttonStyle="pharmabutton-bg ms-2 me-0"
                      handleClick={handleNavigateKendra}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="jana_ourvision home-bg py-3 px-3">
        <div className="container">
          <div className="row">
            {/* Left Section */}
            <div className="jana_ourvision_left_data col-sm-12 col-md-12 col-lg-6 mb-sm-3 mb-md-3 mb-lg-0">
              <div className="card p-3 card-bg h-100">
                <div className="row">
                  <div className="jana_vision_left_sec col-sm-12 col-md-12 col-lg-5">
                    <div className="card text-white">
                      <img
                        src={
                          homeSectionData?.visionData?.[0]?.imageUrl ||
                          AVTAR_IMG
                        }
                        className="img-fluid card-img"
                        alt="..."
                      />
                      <div className="card-img-overlay text-center home-vision-img">
                        <h5 className="card-title text-white img-margin">
                          {Language === "hi"
                            ? homeSectionData?.visionData?.[0]
                              ?.uploadImageHindiResponse?.name
                            : homeSectionData?.visionData?.[0]?.name ||
                            "Shri Narendra Modi"}
                        </h5>
                        <p className="card-text">
                          {Language === "hi"
                            ? homeSectionData?.visionData?.[0]
                              ?.uploadImageHindiResponse?.designation
                            : homeSectionData?.visionData?.[0]?.designation ||
                            "Hon'ble Prime Minister Of India"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="jana_vision_right_sec col-sm-12 col-md-12 col-lg-7">
                    <div className="jana_vision_right_data">
                      <h5 className="card-title">{t("Vision")}</h5>
                      <p className="card-text mb-1">
                        {Language === "hi"
                          ? homeSectionData?.visionData?.[0]
                            ?.uploadImageHindiResponse?.description
                          : homeSectionData?.visionData?.[0]?.description ||
                          "To Bring Down The Healthcare Budget Of Every Citizen Of India Through Providing"}
                      </p>
                      <h5>
                        {Language === "hi"
                          ? homeSectionData?.visionData?.[0]
                            ?.uploadImageHindiResponse?.title
                          : homeSectionData?.visionData?.[0]?.title}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Minister Data Section */}
            {homeSectionData?.ministerData?.map((item, i) => (
              <div
                className="jana_ourvision_mid_data col-lg-3 col-md-6 col-lg-3 mb-sm-3 mb-md-0 mb-lg-0"
                key={i.id}
              >
                <div className="card h-100 card-bg align-items-center">
                  <img
                    src={item?.imageUrl || AVTAR_IMG}
                    className="img-fluid mt-3 w-50"
                    alt="..."
                  />
                  <div className="card-body text-center">
                    <h5 className="card-title">
                      {Language === "hi"
                        ? item?.uploadImageHindiResponse?.name
                        : item?.name}
                    </h5>
                    <p className="card-text">
                      {Language === "hi"
                        ? item?.uploadImageHindiResponse?.description
                        : item?.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}

            {/* Chemicalsinister Category Section */}
            {homeSectionData?.ChemicalsinisterCategory?.map((item, j) => (
              <div
                className="jana_ourvision_mid_data col-lg-3 col-md-6 col-lg-3 mb-sm-3 mb-md-0 mb-lg-0"
                key={j.id}
              >
                <div className="card h-100 card-bg align-items-center">
                  <img
                    src={item?.imageUrl || AVTAR_IMG}
                    className="img-fluid mt-3 w-50"
                    alt="..."
                  />
                  <div className="card-body text-center">
                    <h5 className="card-title">
                      {Language === "hi"
                        ? item?.uploadImageHindiResponse?.name
                        : item?.name}
                    </h5>
                    <p className="card-text">
                      {Language === "hi"
                        ? item?.uploadImageHindiResponse?.description
                        : item?.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="jana_news_sec px-3">
        <div className="jana_news_inner_sec py-4">
          <div className="jana_news_data">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-xl-7 mb-3 mb-sm-3 mb-md-3 mb-lg-0 mb-xl-0">
                  <div className="jana_news_left_sec mb-sm-3 mb-md-3 mb-lg-0">
                    <div className="card text-white">
                      <div className="card-image-sec">
                        <img
                          src={
                            viewLatestUpdate?.imageUrl
                              ? viewLatestUpdate?.imageUrl
                              : homeSectionData?.latestUpdateData?.[0]?.imageUrl
                          }
                          className="card-img"
                          alt="News Shocase"
                        />
                      </div>
                      <div className="slide-img-content card-img-overlay default-overlay">
                        <h6 className="card-title text-white">
                          {viewLatestUpdate?.name
                            ? viewLatestUpdate?.name
                            : homeSectionData?.latestUpdateData?.[0]?.name}
                        </h6>
                        <p className="card-text textForUserinfo">
                          {viewLatestUpdate?.description
                            ? viewLatestUpdate?.description
                            : homeSectionData?.latestUpdateData?.[0]
                              ?.description}
                        </p>
                      </div>
                    </div>
                    <div className="jana_news_carousel mb-2 mt-3">
                      <Slider {...newssettings}>
                        {homeSectionData?.latestUpdateData?.map((item) => (
                          <>
                            <div className="slides">
                              <div class="card h-100">
                                <img
                                  src={item?.imageUrl}
                                  class="card-img-top"
                                  alt="..."
                                />
                                <div class="card-body">

                                  <p
                                    class="card-text cursor-pointer"
                                    onClick={() =>
                                      handleLatestUpdateClick(item)
                                    }
                                  >
                                    {item?.name?.length > 90
                                      ? item?.name?.slice(0, 90) + "..."
                                      : item?.name}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-xl-5">
                  <div className="jana_news_right_sec">
                    <div className="card p-4">
                      <div className="row">
                        <div className="col-6">
                          <button
                            class={`newsletterBtn w-100 ${Type == "WhatsNew" && "newsletterBtnActive"
                              }`}
                            type="button"
                            onClick={() => setType("WhatsNew")}
                          >
                            {t("whatsnew")}
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            class={` newsletterBtn w-100 ${Type == "NewsLatter" && "newsletterBtnActive"
                              }`}
                            type="button"
                            onClick={() => setType("NewsLatter")}
                          >
                            {t("newsletters")}
                          </button>
                        </div>
                      </div>

                      {Type === "WhatsNew" && (
                        <div className="tab-content mt-3">
                          {isLoading ? (
                            <TableLoader />
                          ) : rowData?.length ? (
                            <ul className="list-group list-group-flush">
                              {rowData
                                .filter((item) => item?.type === "WhatsNew")
                                .map((item, index) => (
                                  <li
                                    className="list-group-item"
                                    key={item?.id || index}
                                  >
                                    <h6>{item?.title} :
                                      <span className="newsLetter-font">{item?.discription}</span>
                                    </h6>
                                    <br />
                                    <p
                                      className="text-primary cursor-pointer"
                                      onClick={() =>
                                        handleNavigationNews(item?.id)
                                      }
                                    >
                                      Click Here For Details
                                      {index < 5 && (
                                        <span className="ms-3 badge bg-primary">
                                          New
                                        </span>
                                      )}
                                    </p>
                                  </li>
                                ))}
                              {pageSize < totalElement && <p className="fw-bold fs-5 text-primary ms-3 mt-3 cursor-pointer" onClick={handleShowMoreNews}>Show More</p>}
                            </ul>

                          ) : (
                            <div className="d-flex justify-content-center align-items-center mt-5">
                              <img src={NODATAFOUND} alt="No Data Found" />
                            </div>
                          )}
                        </div>
                      )}

                      {Type === "NewsLatter" && (
                        <div className="tab-content mt-3">
                          {isLoading ? (
                            <TableLoader />
                          ) : rowData?.length ? (
                            <ul className="list-group list-group-flush">
                              {rowData.map(
                                (item, index) =>
                                  item?.type === "NewsLatter" && (
                                    <li
                                      className="list-group-item"
                                      key={item?.id || index}
                                    >
                                      <h6>{item?.title} :
                                        <span className="newsLetter-font">{item?.discription}</span>
                                      </h6>
                                      <br />
                                      <p
                                        className="text-primary cursor-pointer"
                                        onClick={() =>
                                          handleNavigationNews(item?.id)
                                        }
                                      >
                                        Click Here For Details
                                        {index < 5 && (
                                          <span className="ms-3 badge bg-primary">
                                            New
                                          </span>
                                        )}
                                      </p>
                                    </li>
                                  )
                              )}
                              {pageSize < totalElement && <p className="fw-bold fs-5 text-primary ms-3 mt-3 cursor-pointer" onClick={handleShowMoreNews}>Show More</p>}
                            </ul>
                          ) : (
                            <div className="d-flex justify-content-center align-items-center mt-5">
                              <img src={NODATAFOUND} alt="No Data Found" />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="jana_successtory_section">
        <div className="jana_successtory_innersection mb-4 ">
          <div className="container">
            <div className="jana_successtory_heading_sec d-flex align-items-center justify-content-between py-3">
              <div className="jana_succesiframestory_heading">
                <h3 id="headingColor" className="mb-0 ps-3">
                  {t("Videos")}
                </h3>
              </div>
              <div className="jana_successtory_arrow">
                <a href="#">
                  <img
                    className="img-fluid arrow-img me-2"
                    src={ARROW_PREV}
                    alt=""
                  />
                </a>
                <a href="#">
                  <img
                    className="img-fluid arrow-img"
                    src={ARROW_NEXT}
                    alt=""
                  />
                </a>
              </div>
            </div>
            {/* Video Slider */}
            {loading && <TableLoader />}
            {!loading &&
              <Slider {...slidersettings}>
                {videos?.map((item, i) => (
                  <div className="slides">
                    <div class="card homeYTVideo">
                      <iframe
                        key={item?.id}
                        id={`video_${item?.id}`}
                        className="card-img-top"
                        width="367"
                        src={item?.iframe}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                ))}


              </Slider>

            }

          </div>
        </div>
      </div>



      <div className="jana_successtory_section">
        <div className="jana_successtory_innersection mb-4 ">
          <div className="container">
            <div className="jana_successtory_heading_sec d-flex align-items-center justify-content-between py-3">
              <div className="jana_succesiframestory_heading">
                <h3 id="headingColor" className="mb-0 ps-3">
                  {t("Successstory")}
                </h3>
              </div>
              <div className="jana_successtory_arrow">
                <a href="#">
                  <img
                    className="img-fluid arrow-img me-2"
                    src={ARROW_PREV}
                    alt=""
                  />
                </a>
                <a href="#">
                  <img
                    className="img-fluid arrow-img"
                    src={ARROW_NEXT}
                    alt=""
                  />
                </a>
              </div>
            </div>
            {/* Slider for success story */}
            {Successloading && <TableLoader />}
            {!Successloading &&
              <Slider {...slidersettings}>
                {successStoryvideos?.map((item, i) => (
                  <div className="slides">
                    <div className="card homeYTVideo">
                      <iframe
                        key={item?.id}
                        className="card-img-top "
                        width="367"
                        src={item?.iframe}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                      {/* <div class="card-body">
                    <p class="card-text" id="spanColor">
                      {item?.title}
                    </p>
                  </div> */}
                    </div>
                  </div>
                ))}
              </Slider>
            }

          </div>
        </div>
      </div>
      <div className="jana_gallery_section">
        <div className="jana_gallery_innersection pb-4">
          <div className="container">
            <div className="jana_gallery_heading_sec d-flex align-items-center justify-content-between py-3">
              <div className="jana_gallery_heading">
                <h3 id="headingColor" className="mb-0 ps-3">
                  {t("Gallery")}
                </h3>
              </div>
            </div>
            {/* Slider for Gallery */}
            <Slider {...gallerysettings}>
              {homeSectionData?.galleryEventCategory?.map((item, i) => (
                <div className="slides">
                  <div class="card h-100" key={item?.id}>
                    <img className="img-fluid" src={item?.imageUrl || GALLERY_2} alt="" />
                    <div class="card-body card-height">
                      <p class="card-text">
                        {Language === "hi"
                          ? item?.uploadImageHindiResponse?.description
                          : item?.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}


            </Slider>
          </div>
        </div>
      </div>
      {showFraudModal ? (
        <FraudsAlertModal
          handleCloseModal={handleCloseModal}
          setShowFraudModal={setShowFraudModal}
          showFraudModal={showFraudModal}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Home;
